import { configureStore } from "@reduxjs/toolkit";
import staffReducer from './StaffReducer/staffSlice'


export const store = configureStore({
    reducer: {
        'staff':staffReducer
    }
})